<template>
    <div>
        <ContentHeader />
          <div class="serviceBanner" data-aos="fade-out">
            <span>text</span>
          </div>
          <section class="service-page">
			<div class="block">
				<div class="ctInner">
					<h1 class="leadTitle">Monthly Elevator & Escalator Maintenance Services</h1>
					<h2>Keep your lifts safe, smooth, and dependable — every month.</h2>
					<p>Our monthly maintenance program is designed to keep your elevators and escalators running safely and efficiently. Regular preventive care helps detect potential issues early, avoid costly repairs, and maintain comfort and safety for all passengers.</p>
				</div>
			</div>

			<div class="block bgGray">
				<div class="ctInner">
					<h3>What We Check Each Month</h3>
					<dl>
						<dt><strong>Control System Inspection</strong></dt>
						<dd>Review and test all elevator control panels, circuits, and safety relays for proper operation.</dd>
					</dl>
					<dl>
						<dt><strong>Electrical Component Review</strong></dt>
						<dd>Examine all fuses, relays, contactors, switches, and wiring conditions to ensure electrical safety.</dd>
					</dl>
					<dl>
						<dt><strong>Mechanical & Drive Check</strong></dt>
						<dd>Inspect the motor, ropes, belts, and couplings for proper tension and wear.</dd>
					</dl>
					<dl>
						<dt><strong>Door Mechanism Service</strong></dt>
						<dd>Check and lubricate door tracks, rollers, and mechanical parts to ensure smooth, reliable door movement.</dd>
					</dl>
					<dl>
						<dt><strong>Guide Rail & Bearing Maintenance</strong></dt>
						<dd>Clean and lubricate guide rails and brackets to prevent friction and noise.</dd>
					</dl>
					<dl>
						<dt><strong>Car & Counterweight Inspection</strong></dt>
						<dd>Examine the car frame, counterweight, guide shoes, and buffers for proper balance and operation.</dd>
					</dl>
					<dl>
						<dt><strong>Governor & Safety Devices Testing</strong></dt>
						<dd>Inspect the speed governor, limit switches, pit switches, and safety wedges for accuracy and function.</dd>
					</dl>
					<dl>
						<dt><strong>Emergency System Verification</strong></dt>
						<dd>Test emergency phones, auto-rescue systems, and lighting to ensure they function properly in case of power failure.</dd>
					</dl>
					<dl>
						<dt><strong>Fasteners & Wiring Audit</strong></dt>
						<dd>Tighten all bolts and nuts, and check wiring in the lift well for any loose or damaged connections.</dd>
					</dl>
				</div>
			</div>

			<div class="block">
				<div class="ctInner">
					<h3>Benefits of Regular Maintenance</h3>
					<ul>
					<li>Reduces unexpected breakdowns and downtime</li>
					<li>Extends service life of major components</li>
					<li>Enhances safety and passenger comfort</li>
					<li>Maintains compliance with safety standards</li>
					</ul>

					<p><strong><router-link to="/contact">Contact us today</router-link></strong> to schedule your next monthly maintenance visit.</p>
				</div>
			</div>
          </section>
        <ContentFooter />
    </div>
</template>

<script>
  import ContentHeader from '@/components/ContentHeader.vue'
  import ContentFooter from '@/components/ContentFooter.vue'
  export default {
    name: 'OurServicesPage',
    components: {
      ContentHeader,
      ContentFooter
    },
	data() {
		return {
			loading: true
		}
	},
	mounted() {
		this.loading = false;
	}
  }
</script>